<div class="p-4 bg-light rounded shadow">
  <h2 class="h4 font-weight-bold text-dark mb-3">
    Upload Attachments
  </h2>

  <div class="mb-4">
    <!-- Kendo Upload -->
    <kendo-upload
      #kendoUpload
      [multiple]="true"
      [autoUpload]="false"
      [showFileList]="false"
      (select)="onFileSelected($event)"
      (remove)="onRemoveFile($event)"
      (clear)="onClearFiles()"
      (success)="onUploadSuccess($event)"
      (error)="onUploadError($event)"
      [saveUrl]="uploadUrl"
      [removeUrl]="removeUrl"
      class="w-100"
    >
      <ng-template kendoUploadFileTemplate let-files>
        <div class="text-secondary text-center py-4">
          <i class="k-icon k-i-upload k-icon-xl"></i>
          <p class="mt-2 h5">Drag & drop files here</p>
          <p class="small">or</p>
          <button
            type="button"
            class="btn btn-outline-primary mt-2"
            (click)="kendoUpload.fileSelectButton.nativeElement.click()"
          >
            Browse Files
          </button>
        </div>
      </ng-template>
    </kendo-upload>
  </div>

  <!-- File List with Progress -->
  <div *ngIf="files.length > 0" class="mt-3">
    <h3 class="h6 font-weight-semibold text-secondary mb-2">Selected Files</h3>
    <div
      *ngFor="let file of files; let i = index"
      class="d-flex align-items-center bg-light border rounded p-2 mb-2"
    >
      <i class="k-icon k-i-attachment text-primary mr-2"></i>
      <div class="flex-grow-1 overflow-hidden">
        <div class="text-truncate font-weight-medium text-dark">{{ file.name }}</div>
        <kendo-progressbar
          *ngIf="file.progress < 100"
          [value]="file.progress"
          class="mt-1"
          style="height: 6px;"
        ></kendo-progressbar>
        <span *ngIf="file.progress === 100" class="small text-success">
          <i class="k-icon k-i-check-circle"></i> Upload Complete
        </span>
      </div>
      <button
        type="button"
        class="btn btn-link text-danger p-0 ml-2"
        (click)="removeFile(i)"
        aria-label="Remove"
      >
        <i class="k-icon k-i-delete"></i>
      </button>
    </div>
  </div>

  <div class="d-flex justify-content-end mt-4">
    <button type="button" class="btn btn-secondary mr-2">Cancel</button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="syncFiles()"
      [disabled]="!isUploadComplete()"
    >
      Save
    </button>
  </div>
</div>